<template>
   <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body>
  <div class="container">
    <!-- 状态显示 -->
    <div class="status-bar">
      <div class="status-item">
        <span class="status-label">录音状态:</span>
        <span :class="['status-value', isRecording ? 'recording' : '']">
          {{ isRecording ? "录音中" : "未录音" }}
        </span>
      </div>
      <div class="status-item">
        <span class="status-label">连接状态:</span>
        <span :class="['status-value', isConnected ? 'connected' : '']">
          {{ isConnected ? "已连接" : "未连接" }}
        </span>
      </div>
      <div class="status-item">
        <span class="status-label">识别状态:</span>
        <span :class="['status-value', recognitionStatus]">
          {{ statusText }}
        </span>
      </div>
    </div>

    <!-- 控制按钮 -->
    <div class="control-buttons">
      <button
        :class="['record-button', isRecording ? 'stop' : 'start']"
        @click="toggleRecording"
        :disabled="isProcessing"
      >
        <span class="button-icon">{{ isRecording ? "■" : "●" }}</span>
        <span class="button-text">
          {{
            isRecording ? "停止录音" : isProcessing ? "处理中..." : "开始录音"
          }}
        </span>
      </button>
      <!-- <button
        class="retry-button"
        @click="retryConnection"
        :disabled="isProcessing || isRecording"
      >
        重连
      </button>
      <button
        class="upload-button"
        @click="uploadAudio"
        :disabled="!audioBlob || isUploading"
      >
        {{ isUploading ? "上传中..." : "上传音频" }}
      </button> -->
    </div>

    <!-- 实时识别结果 -->
    <div class="real-time-result">
      <span class="section-title">实时识别:</span>
      <div class="temp-text-container">
        <span class="temp-text">{{ tempText || "等待说话..." }}</span>
      </div>
    </div>

    <!-- 最终识别结果 -->
    <div class="final-result">
      <div class="result-header">
        <span class="section-title">识别结果</span>
        <div>
          <button class="clear-btn" @click="clearText" size="mini">清空</button>
          <button class="copy-btn" @click="copyText" size="mini">复制</button>
        </div>
      </div>
      <div class="result-scroll" ref="resultScroll">
        <pre class="result-text">{{ recognizedText || "暂无识别结果" }}</pre>
      </div>
    </div>

    <!-- 使用提示 -->
    <div class="tips">
      <p class="tip-text">• 点击开始录音后说话</p>
      <p class="tip-text">• 说话清晰，背景安静效果更好</p>
      <p class="tip-text">• 实时显示识别结果</p>
      <p class="tip-text" v-if="lastError">• 错误信息: {{ lastError }}</p>
      <p class="tip-text" v-if="audioUrl">
        • <a :href="audioUrl" download="recording.wav">下载录音文件</a>
      </p>
    </div>
  </div>
  <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 科大讯飞配置
const APP_ID = "1b5df891";
const API_SECRET = "MGY0YWUzZWU4NWZkMTI4ZWJhMTVkNjM4";
const API_KEY = "2aacfa28fe3fbbf6fec798fde1f2c0fd";
import axios from "axios";
import CryptoJS from "crypto-js";
import { Base64 } from "js-base64"; // 假设你有 base64 工具

import { BaseUploadImg, addVoiceSynthesis } from "@/api/index";
// 音频参数
const AUDIO_CONFIG = {
  sampleRate: 16000,
  channels: 1,
  format: "pcm",
  frameSize: 1024,
  bufferTime: 100,
};

// WebSocket 配置
const WS_CONFIG = {
  maxRetries: 3,
  retryDelay: 2000,
  timeout: 10000,
};

export default {
  name: "SpeechRecognition",
  data() {
    return {
      isRecording: false,
      isConnected: false,
      isProcessing: false,
      isUploading: false,
      recognizedText: "",
      tempText: "",
      lastError: "",
      recognitionStatus: "idle",

      mediaStream: null,
      audioContext: null,
      scriptProcessor: null,
      websocket: null,
      audioBlob: null,
      audioUrl: "",

      // 重试相关
      retryCount: 0,
      connectionTimeout: null,
      audioQueue: [],
      isSending: false,

      // 识别结果处理相关
      currentSentence: "", // 当前句子的完整结果
      pendingResults: [], // 待处理的结果队列
      lastFinalText: "", // 上一次的最终结果
      isSentenceEnd: true, // 是否句子结束

      // 音频录制相关
      audioChunks: [], // 录音数据块
      mediaRecorder: null, // MediaRecorder 实例,
      autioLink: null, // 录音文件的 URL
      // 弹窗
       title: "",
      // 是否显示弹出层
      open: false,
    };
  },

  computed: {
    statusText() {
      const statusMap = {
        idle: "待机",
        connecting: "连接中...",
        recognizing: "识别中",
        error: "错误",
      };
      return statusMap[this.recognitionStatus] || "未知";
    },
  },

  mounted() {
  },

  beforeDestroy() {
    this.cleanup();
  },

  methods: {
    addCreateForm(userId, userName, platForm) {
      this.open = true;
      this.title = "添加语音";
      this.userId = userId;
      this.userName = userName;
      this.platForm = platForm;
    this.initAudio();
    },
    initAudio() {
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        this.audioContext = new AudioContext({
          sampleRate: AUDIO_CONFIG.sampleRate,
          latencyHint: "interactive",
        });
        console.log("AudioContext 初始化成功");
      } catch (error) {
        console.error("AudioContext 初始化失败:", error);
        this.lastError = "音频设备初始化失败";
      }
    },

    async startRecording() {
      if (this.isRecording || this.isProcessing) return;

      try {
        this.isProcessing = true;
        this.recognitionStatus = "connecting";

        // 重置识别状态
        this.currentSentence = "";
        this.pendingResults = [];
        this.lastFinalText = "";
        this.isSentenceEnd = true;
        this.audioChunks = [];
        this.audioBlob = null;
        this.audioUrl = "";

        if (this.audioContext.state === "suspended") {
          await this.audioContext.resume();
        }

        // 先连接 WebSocket
        await this.connectWebSocket();

        // 再获取麦克风权限
        const constraints = {
          audio: {
            sampleRate: { ideal: AUDIO_CONFIG.sampleRate },
            channelCount: { ideal: AUDIO_CONFIG.channels },
            echoCancellation: true,
            noiseSuppression: true,
            autoGainControl: true,
          },
        };

        this.mediaStream = await navigator.mediaDevices.getUserMedia(
          constraints
        );

        // 初始化 MediaRecorder 用于录制音频文件
        this.initMediaRecorder();

        this.isRecording = true;
        this.recognitionStatus = "recognizing";
        this.recognizedText = "";
        this.tempText = "正在录音...";
        this.lastError = "";
        this.audioQueue = [];
        this.autioLink = null;

        // 创建音频处理节点
        const source = this.audioContext.createMediaStreamSource(
          this.mediaStream
        );
        this.scriptProcessor = this.audioContext.createScriptProcessor(
          AUDIO_CONFIG.frameSize,
          AUDIO_CONFIG.channels,
          AUDIO_CONFIG.channels
        );

        this.scriptProcessor.onaudioprocess = (e) => {
          if (!this.isRecording || !this.isConnected) return;

          const inputData = e.inputBuffer.getChannelData(0);
          const buffer = this.floatTo16BitPCM(inputData);

          this.audioQueue.push(buffer);

          if (!this.isSending) {
            this.processAudioQueue();
          }
        };

        source.connect(this.scriptProcessor);
        this.scriptProcessor.connect(this.audioContext.destination);

        console.log("录音开始");
        this.isProcessing = false;
      } catch (err) {
        console.error("启动录音失败:", err);
        this.lastError = `启动失败: ${err.message}`;
        this.recognitionStatus = "error";
        this.isProcessing = false;
        this.stopRecording();
      }
    },

    initMediaRecorder() {
      try {
        // 使用 WAV 格式录制，兼容性更好
        const options = {
          mimeType: "audio/webm;codecs=opus",
          audioBitsPerSecond: 128000,
        };

        // 尝试创建 MediaRecorder
        this.mediaRecorder = new MediaRecorder(this.mediaStream, options);

        this.mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            this.audioChunks.push(event.data);
          }
        };

        this.mediaRecorder.onstop = () => {
          this.createAudioBlob();
        };

        // 开始录制，设置时间片为 1000ms
        this.mediaRecorder.start(1000);
        console.log("MediaRecorder 开始录制");
      } catch (error) {
        console.warn("MediaRecorder 初始化失败，使用备用方案:", error);
        this.mediaRecorder = null;
      }
    },

    createAudioBlob() {
      if (this.audioChunks.length === 0) return;

      const blob = new Blob(this.audioChunks, { type: "audio/webm" });
      this.audioBlob = blob;
      this.audioUrl = URL.createObjectURL(blob);
      console.log("音频文件创建完成，大小:", blob.size, "bytes");
    },

    async processAudioQueue() {
      if (this.audioQueue.length === 0 || !this.isConnected) {
        this.isSending = false;
        return;
      }

      this.isSending = true;

      try {
        const framesToProcess = this.audioQueue.splice(0, 3);

        for (const buffer of framesToProcess) {
          if (this.isConnected) {
            this.sendAudioFrame(buffer);
            await this.delay(30);
          }
        }
      } catch (error) {
        console.error("处理音频队列失败:", error);
      }

      if (this.audioQueue.length > 0) {
        setTimeout(() => this.processAudioQueue(), 10);
      } else {
        this.isSending = false;
      }
    },

    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    stopRecording() {
      if (!this.isRecording) return;

      this.isRecording = false;
      this.isProcessing = true;
      this.tempText = "录音结束，正在处理...";

      // 停止 MediaRecorder
      if (this.mediaRecorder && this.mediaRecorder.state === "recording") {
        this.mediaRecorder.stop();
      }

      // 清理音频资源
      this.cleanupAudio();

      // 发送结束帧
      if (this.isConnected) {
        setTimeout(() => {
          this.sendEndFrame();
        }, 500);
      }

      // 清理队列
      this.audioQueue = [];

      setTimeout(() => {
        this.isProcessing = false;
        this.recognitionStatus = this.isConnected ? "idle" : "error";
      }, 1000);
    },

    toggleRecording() {
      this.isRecording ? this.stopRecording() : this.startRecording();
    },

    cleanupAudio() {
      if (this.scriptProcessor) {
        try {
          this.scriptProcessor.disconnect();
          this.scriptProcessor.onaudioprocess = null;
        } catch (e) {
          console.error("清理 scriptProcessor 失败:", e);
        }
        this.scriptProcessor = null;
      }

      if (this.mediaStream) {
        try {
          this.mediaStream.getTracks().forEach((track) => {
            track.stop();
            track.enabled = false;
          });
        } catch (e) {
          console.error("清理 mediaStream 失败:", e);
        }
        this.mediaStream = null;
      }
    },

    cleanup() {
      this.stopRecording();

      if (this.websocket) {
        this.websocket.onclose = null;
        this.websocket.onerror = null;
        this.websocket.onmessage = null;
        this.websocket.close();
        this.websocket = null;
      }

      if (this.connectionTimeout) {
        clearTimeout(this.connectionTimeout);
        this.connectionTimeout = null;
      }

      // 清理音频 URL
      if (this.audioUrl) {
        URL.revokeObjectURL(this.audioUrl);
      }

      this.isConnected = false;
    },

    async connectWebSocket() {
      return new Promise((resolve, reject) => {
        if (this.connectionTimeout) {
          clearTimeout(this.connectionTimeout);
        }

        this.connectionTimeout = setTimeout(() => {
          reject(new Error("连接超时"));
        }, WS_CONFIG.timeout);

        try {
          const authParams = this.generateAuthParams();
          const wsUrl = `wss://iat-api.xfyun.cn/v2/iat?${authParams}`;

          console.log("正在连接 WebSocket...");
          this.websocket = new WebSocket(wsUrl);

          this.websocket.onopen = () => {
            clearTimeout(this.connectionTimeout);
            console.log("WebSocket 连接成功");
            this.isConnected = true;
            this.retryCount = 0;
            this.lastError = "";
            this.tempText = "连接成功，开始识别...";
            this.sendStartFrame();
            resolve();
          };

          this.websocket.onmessage = (event) => {
            this.handleWebSocketMessage(event.data);
          };

          this.websocket.onerror = (error) => {
            console.error("WebSocket 错误:", error);
            this.lastError = "连接错误，请检查网络";
            reject(error);
          };

          this.websocket.onclose = (event) => {
            console.log("WebSocket 已关闭:", event.code, event.reason);
            this.isConnected = false;

            if (this.isRecording && event.code !== 1000) {
              this.lastError = `连接断开: ${event.reason || "未知原因"}`;
              this.autoReconnect();
            }
          };
        } catch (error) {
          clearTimeout(this.connectionTimeout);
          console.error("连接异常:", error);
          this.lastError = `连接异常: ${error.message}`;
          reject(error);
        }
      });
    },

    autoReconnect() {
      if (this.retryCount < WS_CONFIG.maxRetries && this.isRecording) {
        this.retryCount++;
        console.log(`尝试重连 (${this.retryCount}/${WS_CONFIG.maxRetries})...`);
        this.tempText = `连接断开，正在重连 (${this.retryCount}/${WS_CONFIG.maxRetries})...`;

        setTimeout(() => {
          if (this.isRecording) {
            this.connectWebSocket().catch((error) => {
              console.error("重连失败:", error);
              this.autoReconnect();
            });
          }
        }, WS_CONFIG.retryDelay);
      } else if (this.isRecording) {
        this.lastError = "重连次数超限，请手动重试";
        this.stopRecording();
      }
    },

    async retryConnection() {
      if (this.isProcessing || this.isRecording) return;

      this.isProcessing = true;
      this.lastError = "正在重连...";

      try {
        await this.connectWebSocket();
        this.lastError = "";
      } catch (error) {
        this.lastError = `重连失败: ${error.message}`;
      } finally {
        this.isProcessing = false;
      }
    },

    generateAuthParams() {
      const host = "iat-api.xfyun.cn";
      const date = new Date().toUTCString();
      const algorithm = "hmac-sha256";
      const headers = "host date request-line";
      const signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/iat HTTP/1.1`;

      const signature = CryptoJS.HmacSHA256(
        signatureOrigin,
        API_SECRET
      ).toString(CryptoJS.enc.Base64);
      const authorization = `api_key="${API_KEY}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`;
      const encoded = Base64.encode(authorization);

      return `authorization=${encodeURIComponent(
        encoded
      )}&date=${encodeURIComponent(date)}&host=${encodeURIComponent(host)}`;
    },

    sendStartFrame() {
      const startFrame = {
        common: { app_id: APP_ID },
        business: {
          language: "zh_cn",
          domain: "iat",
          accent: "mandarin",
          vad_eos: 10000,
          dwa: "wpgs", // 启用增量返回
        },
        data: {
          status: 0,
          format: "audio/L16;rate=16000",
          audio: "",
          encoding: "raw",
        },
      };
      this.sendWebSocketMessage(startFrame);
    },

    sendAudioFrame(buffer) {
      if (
        !this.isConnected ||
        !this.websocket ||
        this.websocket.readyState !== WebSocket.OPEN
      ) {
        return;
      }

      try {
        const base64Audio = this.arrayBufferToBase64(buffer);
        const frame = {
          data: {
            status: 1,
            format: "audio/L16;rate=16000",
            audio: base64Audio,
            encoding: "raw",
          },
        };
        this.sendWebSocketMessage(frame);
      } catch (error) {
        console.error("发送音频帧失败:", error);
      }
    },

    sendEndFrame() {
      if (!this.isConnected || !this.websocket) return;

      const endFrame = {
        data: {
          status: 2,
          format: "audio/L16;rate=16000",
          audio: "",
          encoding: "raw",
        },
      };

      try {
        this.sendWebSocketMessage(endFrame);
      } catch (error) {
        console.error("发送结束帧失败:", error);
      }
    },

    sendWebSocketMessage(message) {
      if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
        try {
          this.websocket.send(JSON.stringify(message));
        } catch (error) {
          console.error("发送 WebSocket 消息失败:", error);
          this.lastError = "发送数据失败";
        }
      }
    },

    handleWebSocketMessage(data) {
      try {
        const result = JSON.parse(data);
        console.log("收到识别结果:", result);

        if (result.code !== 0) {
          console.error("识别错误:", result);
          this.lastError = `识别错误: ${result.code} - ${
            result.message || "未知错误"
          }`;

          if (result.code === 10105 || result.code === 10106) {
            this.stopRecording();
          }
          return;
        }

        this.processRecognitionResult(result);
      } catch (e) {
        console.error("解析消息失败:", e, data);
      }
    },

    processRecognitionResult(result) {
      if (!result.data?.result?.ws) return;

      try {
        const text = result.data.result.ws
          .map((item) => item.cw[0]?.w || "")
          .join("");

        console.log("识别状态:", result.data.status, "文本:", text);

        if (result.data.status === 0) {
          // 开始帧响应
          console.log("识别开始");
          this.tempText = "开始识别...";
          this.currentSentence = "";
          this.pendingResults = [];
        } else if (result.data.status === 1) {
          // 中间结果 - 使用 WPGS 协议处理增量结果
          this.handleIntermediateResult(text, result.data);
          // this.handleFinalResult(text);
        } else if (result.data.status === 2) {
          // 最终结果
          this.handleFinalResult(text);
        }
      } catch (error) {
        console.error("处理识别结果失败:", error);
      }
    },

    handleIntermediateResult(text, data) {
      if (!text.trim()) return;

      // 使用 WPGS 协议处理增量结果
      if (data.result && data.result.pgs) {
        const pgs = data.result.pgs;

        if (pgs === "rpl") {
          // 替换之前的结果
          this.currentSentence = text;
        } else {
          // 追加或更新结果
          this.currentSentence = text;
        }

        this.tempText = this.currentSentence;
      } else {
        // 如果没有 WPGS，直接显示当前结果
        this.tempText = text;
      }
    },

    handleFinalResult(text) {
      if (text && text.trim()) {
        // 将最终结果添加到识别文本中
        const finalText = this.currentSentence || text;
        if (finalText.trim()) {
          this.recognizedText += finalText + "\n";
          this.tempText = "";
          this.currentSentence = "";
          this.$nextTick(() => {
            this.scrollToBottom();
            this.uploadAudio()
          });
        }
      }
    },

    scrollToBottom() {
      if (this.$refs.resultScroll) {
        const scrollElement = this.$refs.resultScroll;
        scrollElement.scrollTop = scrollElement.scrollHeight;
      }
    },
    async uploadAudio() {
      if (!this.audioBlob || this.isUploading) return;

      this.isUploading = true;
      this.lastError = "";

      try {
        const base64Audio = await this.blobToBase64(this.audioBlob);
        BaseUploadImg({
          file: base64Audio,
        })
          .then((res) => {
            this.autioLink = res.data.data;
            console.log("上传成功", res, this.autioLink);
          })
          .catch((err) => {
            console.log("上传失败", err);
          });
      } catch (error) {
        console.error("上传音频失败:", error);
        this.lastError = `上传失败: ${error.message}`;
      } finally {
        this.isUploading = false;
      }
    },

    // 将 Blob 转换为 base64
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },
    // Float32Array → 16位PCM ArrayBuffer
    floatTo16BitPCM(floatArray) {
      const buffer = new ArrayBuffer(floatArray.length * 2);
      const view = new DataView(buffer);
      let offset = 0;
      for (let i = 0; i < floatArray.length; i++) {
        const s = Math.max(-1, Math.min(1, floatArray[i]));
        view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
        offset += 2;
      }
      return buffer;
    },

    // ArrayBuffer → Base64
    arrayBufferToBase64(buffer) {
      const bytes = new Uint8Array(buffer);
      let binary = "";
      for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return btoa(binary);
    },

    clearText() {
      this.recognizedText = "";
      this.tempText = "";
      this.currentSentence = "";
      this.pendingResults = [];
    },

    copyText() {
      if (!this.recognizedText) return;

      navigator.clipboard
        .writeText(this.recognizedText)
        .then(() => {
          alert("复制成功");
        })
        .catch(() => {
          const textArea = document.createElement("textarea");
          textArea.value = this.recognizedText;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);
          alert("复制成功");
        });
    },
      /** 提交按钮 */
    submitForm() {
      const data = {
        content: this.recognizedText,
        voiceLink: this.autioLink,
        userId: this.userId,
        userName: this.userName,
        platForm: this.platForm,
        type:2
      };
      addVoiceSynthesis(data).then((response) => {
        this.$modal.msgSuccess("新增成功");
        this.open = false;
        this.$emit("ok");
      });
    },
     cancel() {
      this.open = false;
      this.reset();
    },
     reset() {
      this.cleanup();
      this.clearText();
    },
  },
};
</script>

<style scoped>
.container {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  background: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.status-bar {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
  font-size: 14px;
  flex-wrap: wrap;
  gap: 10px;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

.status-label {
  color: #555;
}

.status-value {
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: bold;
}

.status-value.recording {
  background: #ffebee;
  color: #c62828;
}

.status-value.connected {
  background: #e8f5e8;
  color: #2e7d32;
}

.status-value.recognizing {
  background: #fff3e0;
  color: #ef6c00;
}

.status-value.error {
  background: #ffebee;
  color: #c62828;
}

.control-buttons {
  text-align: center;
  margin: 20px 0;
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
}

.record-button,
.retry-button,
.upload-button {
  padding: 12px 20px;
  border: none;
  border-radius: 30px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.record-button:disabled,
.retry-button:disabled,
.upload-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.record-button.start {
  background: #4caf50;
  color: white;
}

.record-button.stop {
  background: #f44336;
  color: white;
}

.retry-button {
  background: #2196f3;
  color: white;
}

.upload-button {
  background: #ff9800;
  color: white;
}

.button-icon {
  font-size: 16px;
}

.real-time-result,
.final-result {
  margin: 20px 0;
  background: white;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.section-title {
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  display: block;
}

.temp-text-container {
  min-height: 40px;
  color: #666;
  font-style: italic;
  padding: 10px;
  background: #fafafa;
  border-radius: 4px;
}

.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.clear-btn,
.copy-btn {
  padding: 4px 8px;
  margin-left: 8px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.clear-btn:hover,
.copy-btn:hover {
  background: #f5f5f5;
}

.result-scroll {
  height: 200px;
  overflow-y: auto;
  background: #fafafa;
  padding: 10px;
  border-radius: 4px;
  white-space: pre-wrap;
  border: 1px solid #eee;
}

.result-text {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  margin: 0;
}

.tips {
  font-size: 13px;
  color: #777;
  margin-top: 20px;
  padding: 10px;
  background: #f0f8ff;
  border-radius: 6px;
}

.tip-text {
  margin: 5px 0;
}

.tip-text a {
  color: #2196f3;
  text-decoration: none;
}

.tip-text a:hover {
  text-decoration: underline;
}
</style>